import img1 from '../images/product-item/item-5.jpg'
import img2 from '../images/product-item/item-6.jpg'
import img3 from '../images/product-item/item-10.jpg'
import img4 from '../images/product-item/item-11.jpg'
import img5 from '../images/product-item/item-7.jpg'
import img6 from '../images/product-item/item-8.jpg'
import img7 from '../images/product-item/item-9.jpg'
import imga1 from '../images/avatar/avt-7.jpg'
import imga2 from '../images/avatar/avt-13.jpg'
import imga3 from '../images/avatar/avt-14.jpg'
import imga4 from '../images/avatar/avt-15.jpg'

const dataCollections = [
    {
        img: img1,
        title: '‘’3D Space Rocket With Smoke Premium’’',
        tags: 'BSC',
        imgAuthor: imga1,
        name:'Daniel M.Bivens',
        styleclass: 'tf-col-item',
        col: 'col-md-3'
    },
    // {
    //     img: img2,
    //     img1: img5,
    //     img2: img6,
    //     img3: img7,
    //     title: '‘’Multi-purpose 3D Space Rocket With Animate Real Special Smoke Premium Quality Gaming’’',
    //     tags: 'BSC',
    //     imgAuthor: imga2,
    //     name:'Daniel M.Bivens',
    //     styleclass: 'tf-col-itemx2',
    //     wishlist: '152k',
    //     col: 'col-md-6'
    // },
    {
        img: img3,
        title: '‘’3D Space Rocket With Smoke Premium’’',
        tags: 'BSC',
        imgAuthor: imga3,
        name:'Daniel M.Bivens',
        styleclass: 'tf-col-item',
        col: 'col-md-3'
    },
    {
        img: img4,
        title: '‘’3D Space Rocket With Smoke Premium’’',
        tags: 'BSC',
        imgAuthor: imga4,
        name:'Daniel M.Bivens',
        styleclass: 'tf-col-item',
        col: 'col-md-3'
    },
    {
        img: img1,
        title: '‘’3D Space Rocket With Smoke Premium’’',
        tags: 'BSC',
        imgAuthor: imga1,
        name:'Daniel M.Bivens',
        styleclass: 'tf-col-item',
        col: 'col-md-3'
    },
    // {
    //     img: img2,
    //     img1: img5,
    //     img2: img6,
    //     img3: img7,
    //     title: '‘’Multi-purpose 3D Space Rocket With Animate Real Special Smoke Premium Quality Gaming’’',
    //     tags: 'BSC',
    //     imgAuthor: imga2,
    //     name:'Daniel M.Bivens',
    //     styleclass: 'tf-col-itemx2',
    //     wishlist: '152k',
    //     col: 'col-md-6'
    // },
    {
        img: img3,
        title: '‘’3D Space Rocket With Smoke Premium’’',
        tags: 'BSC',
        imgAuthor: imga3,
        name:'Daniel M.Bivens',
        styleclass: 'tf-col-item',
        col: 'col-md-3'
    },
    {
        img: img4,
        title: '‘’3D Space Rocket With Smoke Premium’’',
        tags: 'BSC',
        imgAuthor: imga4,
        name:'Daniel M.Bivens',
        styleclass: 'tf-col-item',
        col: 'col-md-3'
    },
    

]

export default dataCollections;